import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { ApiKey } from '@/types/user';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getApiKeys = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<ApiKey[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<ApiKey[]>>('/organization/client', options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
